import { Ifilter } from "../filter";

export interface IDataTableActividades {
  actividadId: string;
  nombre: string;
  equipo: string;
  fechaCreada: string;
}
export interface ITableFIlterIpercActividades {
  skip: number;
  take: number;
  search?: string | null;
}
export interface IRequestFilterActividades extends Ifilter{
  personaId:string
}

export const InitialFilterIpercActividades = {
  skip: 0,
  take: 50,
  search: "",
};

export interface IDataActividades {
  actividadId: string;
  nombre: string;
  created: string;
}
export interface IActualizarActividad {
  actividadId: string;
  nombre: string;
}

export interface IPostCrearActividad {
  nombre: string;
  equipoId: string;
}

export interface IFilterEquipo {
  search: string | null;
}